module.exports = __webpack_public_path__ + "assets/img/worldviewImgActive-485874ec.png";